import { useMutation } from "@tanstack/react-query";
import type { CustomRiskEditRequestInput } from "@unbox/api";
import { handleError } from "@/api/error";
import { client, useScopedMerchantClient } from "../scoped-merchant-client";

export const useCreateCustomRiskEditRequest = () => {
  const scope = useScopedMerchantClient();

  return useMutation({
    mutationFn: async (input: CustomRiskEditRequestInput) => {
      if (!scope.merchantId) throw new Error("No merchant selected");

      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].safety["custom-risk-request"].edit.$post({
            param: scope.param,
            json: input,
          })
        : await client.merchant[":merchantId"].safety["custom-risk-request"].edit.$post({
            param: scope.param,
            json: input,
          });

      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};
